import React, { useContext, useEffect, useState } from "react";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Toast from "../Toast/Toast";
import { API } from "../../config/api";
import { BookContext } from "../../context/bookContext";
import { LoginContext } from "../../context/loginContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePickerInput from "./DatePickerInput";
import LoaderButton from "../Skeleton/LoaderButton";

function AddBookForm(props) {
  const [DataExist, setDataExist] = useState(false);
  const [show, setshow] = useState(false);
  const [state, dispatch] = useContext(BookContext);
  const [loginState] = useContext(LoginContext);
  const [loading, setloading] = useState(false);

  const initialValues = {
    title: "",
    publication: "",
    category: "",
    pages: "",
    isbn: "",
    about: "",
    thumbnailImg: null,
    file: null,
  };

  const Schema = Yup.object().shape({
    title: Yup.string().required("Title Not Allow To Empty"),
    publication: Yup.string().required("Publication Not Allow To Empty"),
    category: Yup.string().required("Please Select Category"),
    pages: Yup.number().required("Pages Not Allow To Empty"),
    isbn: Yup.number().required("ISBN Not Allow To Empty"),
    about: Yup.string().required("About Not Allow To Empty"),
    file: Yup.mixed()
      .nullable("File Not Allow To Empty")
      .test(
        "fileFormat",
        "EPUB only",
        (value) => value && ["application/epub+zip"].includes(value.type)
      )
      .test(
        "fileSize",
        "File Size is too large Max 2 Mb",
        (value) => value && value.size <= 2 * 1000 * 1000
      ),
    thumbnailImg: Yup.mixed()
      .nullable("File Not Allow To Empty")
      .test(
        "fileFormat",
        "Image With Format JPEG,JPG,PNG only",
        (value) => value && ["image/jpeg", "image/png"].includes(value.type)
      )
      .test(
        "fileSize",
        "File Size is too large Max 2 Mb",
        (value) => value && value.size <= 2 * 1000 * 1000
      ),
  });

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await API.get("/categories");
        dispatch({
          type: "GET_CATEGORIES",
          payload: res.data.data,
        });
      } catch (error) {
        dispatch({
          type: "ERROR",
        });
      }
    };
    if (!state.bookCategories) {
      getCategory();
    }
  }, []);

  const handleSubmit = async (e, action) => {
    setloading(true);
    try {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      let body = new FormData();

      if (!loginState.loading) {
        if (loginState.user.isAdmin === "1") {
          body.append("status", "Approved");
        }
      }
      body.append("title", e.title);
      body.append("publication", e.publication);
      body.append("categoryId", e.category);
      body.append("pages", e.pages);
      body.append("ISBN", e.isbn);
      body.append("aboutBook", e.about);
      body.append("thumbnailImg", e.thumbnailImg);
      body.append("file", e.file);
      await API.post("/book", body, config);
      setDataExist(false);
      action.resetForm(initialValues);
      setselectedTime(null);
      setshow(!show);
      setloading(false);
    } catch (err) {
      if (err) {
        if (err.response.status === 409) {
          setDataExist(true);
          setshow(!show);
        }
      }
      setloading(false);
    }
  };

  const dateFormatFunction = (date) => {
    const dateParse = new Date(date);
    const tahun = dateParse.getFullYear();
    const bulan = dateParse.getMonth();
    const tanggal = dateParse.getDate();
    let newDate = "";
    switch (bulan) {
      case 0:
        newDate = `${tanggal} Januari ${tahun}`;
        break;
      case 1:
        newDate = `${tanggal} Februari ${tahun}`;
        break;
      case 2:
        newDate = `${tanggal} Maret ${tahun}`;
        break;
      case 3:
        newDate = `${tanggal} April ${tahun}`;
        break;
      case 4:
        newDate = `${tanggal} Mei ${tahun}`;
        break;
      case 5:
        newDate = `${tanggal} Juni ${tahun}`;
        break;
      case 6:
        newDate = `${tanggal} Juli ${tahun}`;
        break;
      case 7:
        newDate = `${tanggal} Agustus ${tahun}`;
        break;
      case 8:
        newDate = `${tanggal} September ${tahun}`;
        break;
      case 9:
        newDate = `${tanggal} Oktober ${tahun}`;
        break;
      case 10:
        newDate = `${tanggal} November ${tahun}`;
        break;
      case 11:
        newDate = `${tanggal} Desember ${tahun}`;
        break;
      default:
        return null;
    }
    return newDate;
  };

  const [selectedTime, setselectedTime] = useState(null);

  return (
    <div className="">
      <Formik
        initialValues={initialValues}
        validationSchema={Schema}
        onSubmit={(e, action) => {
          handleSubmit(e, action);
        }}
      >
        {(formik) => {
          const {
            errors,
            touched,
            isValid,
            dirty,
            setFieldValue,
            values,
          } = formik;
          return (
            <Form className="w-full max-w-full ">
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-title"
                  >
                    Title*
                  </label>
                  <Field
                    className={`appearance-none block w-full bg-gray-200 text-gray-700 border ${
                      errors.title && touched.title
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-500"
                    } rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white  `}
                    id="grid-title"
                    type="text"
                    placeholder="Title"
                    name="title"
                  />
                  <ErrorMessage
                    name="title"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-date"
                  >
                    Publication Date*
                  </label>
                  <DatePickerInput
                    selected={selectedTime}
                    onChange={(date) => {
                      setFieldValue("publication", dateFormatFunction(date));
                      setselectedTime(date);
                    }}
                    dateFormat="MMMM d, yyyy"
                    placeholderText="Publication"
                    className={`${
                      errors.publication && touched.publication
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-500"
                    } appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white `}
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-category"
                  >
                    Category*
                  </label>

                  <Field
                    name="category"
                    as="select"
                    className={`appearance-none block w-full bg-gray-200 ${
                      errors.category && touched.category
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-500"
                    } border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white `}
                  >
                    <option disabled>Select Category</option>
                    {state.loading ? (
                      <option>Loading...</option>
                    ) : state.error ? (
                      <p>Error Happend</p>
                    ) : (
                      state.bookCategories.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })
                    )}
                  </Field>
                  <ErrorMessage
                    name="category"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-pages"
                  >
                    Pages*
                  </label>
                  <Field
                    className={`${
                      errors.pages && touched.pages
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-500"
                    } appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white `}
                    id="grid-pages"
                    type="number"
                    placeholder="Pages"
                    name="pages"
                  />
                  <ErrorMessage
                    name="pages"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-isbn"
                  >
                    ISBN*
                  </label>
                  <Field
                    className={`${
                      errors.isbn && touched.isbn
                        ? "border-red-500 focus:border-red-500"
                        : "border-gray-200 focus:border-gray-500"
                    } appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white `}
                    id="grid-isbn"
                    type="text"
                    placeholder="ISBN"
                    name="isbn"
                  />
                  <ErrorMessage
                    name="isbn"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-about"
                  >
                    About*
                  </label>
                  <CKEditor
                    editor={ClassicEditor}
                    onChange={(event, editor) => {
                      const ckData = editor.getData();
                      setFieldValue("about", ckData);
                    }}
                    data={values.about}
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="gridThumbnail"
                  >
                    Thumbnail*
                  </label>
                  <button
                    className="bg-orange-custom px-3 py-3 focus:outline-none rounded-md text-white"
                    onClick={() =>
                      document.getElementById("thumbnailImg").click()
                    }
                  >
                    Attach Thumbnail
                  </button>
                  <p>
                    {values.thumbnailImg !== null
                      ? values.thumbnailImg.name
                      : ""}
                  </p>
                  <input
                    className="hidden border-gray-200 appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white "
                    type="file"
                    placeholder="Attach Book File"
                    name="thumbnailImg"
                    id="thumbnailImg"
                    onChange={(e) =>
                      setFieldValue("thumbnailImg", e.currentTarget.files[0])
                    }
                  />
                  <ErrorMessage
                    name="thumbnailImg"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex flex-wrap mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-about"
                  >
                    File*
                  </label>
                  <button
                    className="bg-orange-custom px-3 py-3 focus:outline-none rounded-md text-white"
                    onClick={() => document.getElementById("file").click()}
                  >
                    Attach File
                  </button>
                  <p>{values.file !== null ? values.file.name : ""}</p>
                  <input
                    className="hidden border-gray-200 appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white "
                    type="file"
                    placeholder="Attach Book File"
                    name="file"
                    id="file"
                    onChange={(e) =>
                      setFieldValue("file", e.currentTarget.files[0])
                    }
                  />
                  <ErrorMessage
                    name="file"
                    component="p"
                    className="text-red-500 text-xs italic"
                  />
                </div>
              </div>
              <div className="flex mb-6 justify-end">
                <div className="px-3">
                  <button
                    type="submit"
                    disabled={!(dirty && isValid) || loading}
                    className={` ${
                      !(dirty && isValid)
                        ? "bg-gray-500 cursor-not-allowed"
                        : "bg-orange-custom hover:shadow-lg"
                    } focus:outline-none px-4 text-lg  py-2 text-white rounded-md flex items-center`}
                  >
                    {loading ? <LoaderButton /> : "Add Book"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <Toast
        toggleToast={() => setshow(!show)}
        show={show}
        title={
          loginState.user.isAdmin === "0" ||
          loginState.user.isAdmin === null ||
          !loginState.user.isAdmin
            ? DataExist
              ? "Book Already Exist In Database"
              : "Thank you for adding your own books to our website, please wait 1 x 24 hours to verify whether this book is your writing"
            : DataExist
            ? "Book Already Exist In Database"
            : "Successfully Add Book"
        }
      />
    </div>
  );
}

export default AddBookForm;
